import React, { Component } from 'react';
// connect is what allows us to connect a component to Redux's store
import { connect } from 'react-redux';
import io from "socket.io-client";
import { Header, Modal, Button, Container } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { socketUrl } from '../actions';
import { 
    fetchInboxInstructions,
    fetchRule,
    instructionsAddReceived,
    instructionCancelReceived,
    instructionValidateReceived,
    instructionSeeReceived,
    instructionRejectReceived,
    instructionBanReceived,
    instructionEditReceived,
    setUpAlarmInstructionReceived,
    fetchOpenAlarms,
    fetchUnits,
    refreshDIsSocket,
    fetchEcoDispatchInstructions } from '../actions/footer-actions';
import { 
    fetchToDoList,
    fetchToDoHCList
} from '../actions/to-do-actions';
import { notifyMe } from '../utils/validate'
import { 
    isCTCH, 
    isUNGE,
    isSINES, 
    isRIBATEJO, 
    isLARES,
    isIndipsAdmin,
    isReader,
    isPRODHC,
    isCOMHC,
    isGDEHC,
    isDGEHC,
    isGDEABO
 } from '../utils/user-profile';
const moment = require('moment');
const inlineStyle = {
    modal : {
      marginTop: '0px !important',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '500px'
    }
};
//var sound;
var soundAlarmNewIds;
var soundAlarmIndisp;
var soundAlarmNewIOs;
var timer;
var timerIndisps;
var timerSocketStatus;
var timerDIsRefresh;
let socket;

//este component serve para carregar os ficheiros de audio q sao corridos quando há alertas
//Estão neste componente genérico carregado na App para estarem disponiveis em todos as páginas da aplicação
//e assim os users recebem alertas sonoros e notificações mesmo que n estejam nas páginas de IDs
class LayoutFooter extends Component {
    constructor(props) {
        super(props);
        this.checkSocketStatus = this.checkSocketStatus.bind(this);
        this.checkForCloseIDs = this.checkForCloseIDs.bind(this);
        this.checkForIndispsAlarms = this.checkForIndispsAlarms.bind(this);
        this.openModalNewIDs = this.openModalNewIDs.bind(this);
        this.emitToCloseModalNewIDs = this.emitToCloseModalNewIDs.bind(this);
        this.closeModalNewIDs = this.closeModalNewIDs.bind(this);
        this.openModalNewIndispsAlarms = this.openModalNewIndispsAlarms.bind(this);
        this.emitToCloseModalNewIndispsAlarms = this.emitToCloseModalNewIndispsAlarms.bind(this);
        this.closeModalNewIndispsAlarms = this.closeModalNewIndispsAlarms.bind(this);
        this.openModalNewIOs = this.openModalNewIOs.bind(this);
        this.emitToCloseModalNewIOs = this.emitToCloseModalNewIOs.bind(this);
        this.closeModalNewIOs = this.closeModalNewIOs.bind(this);
        this.playSound = this.playSound.bind(this);
        this.checkForDIsChanges = this.checkForDIsChanges.bind(this);

        this.state = {
            timer: null, //timer to alert operators
            timerIndisps: null,
            modalOpenNewIDs: false,
            newMessageNewIDs: '',
            modalOpenNewIOs: false,
            newMessageNewIOs: '',
            modalOpenNewIndispsAlarms: false,
            newAlarmMessage: [],
            arrayIds: [],
            repeatPlay: false,
            errorReconnectAttempts: 0,
            timerDIsRefresh: null
        };   
    }
  
    componentDidMount() {
        //vamos montar a alarmística com base no país, equipa e perfil do utilizador
        //begin bloco comum aos dois países
        socket = io.connect(socketUrl);
        const CTCH = isCTCH(this.props.user);
        const UNGE = isUNGE(this.props.user);
        const SINES = isSINES(this.props.user);
        const LARES = isLARES(this.props.user);
        const RIBATEJO = isRIBATEJO(this.props.user);
        const INDISPADMIN = isIndipsAdmin(this.props.user);
        const READER = isReader(this.props.user);
        const PRODHC = isPRODHC(this.props.user);
        const COMHC = isCOMHC(this.props.user);
        const GDEHC = isGDEHC(this.props.user);
        const DGEHC = isDGEHC(this.props.user);
        const GDEABO = isGDEABO(this.props.user);
        const userCompany = this.props.user.profile.COMPANY.substring(0, 4);
        const userProfile = this.props.user.profile.PROFILE;
        const userCountry = this.props.user.profile.COUNTRY_CODE;

        console.log(socketUrl);

        socket.on('connect', () => {
            //console.log("Socket.io connected footer: " + socket.connected);
            if(timerSocketStatus){//se faz um reconnect tem de limpar o interval definido anteriormente, caso n o faça, começa a criar vários
                clearInterval(timerSocketStatus);
                this.setState({
                    timerSocketStatus: null
                });
            }
            //sempre que se conecta, inicia timer de check session on e reinicia number of reconnect attempts
            timerSocketStatus = setInterval( this.checkSocketStatus,5000);
            this.setState({ 
                timerSocketStatus: timerSocketStatus,
                errorReconnectAttempts: 0
            });
        });

        socket.on('connect_error', (error) => {
            console.log("Socket.io connect error footer: " + error);
            socket.connect();
        });
        
        socket.on('error', (error) => {
            console.log("Socket.io generic error footer: " + error);
            socket.connect();
        });

        socket.on('connect_timeout', (timeout) => {
            console.log("Socket.io timeout footer: " + timeout);
            socket.connect();
        });

        socket.on('disconnect', (reason) => {            
            if (reason === 'io server disconnect') {
                // the disconnection was initiated by the server, you need to reconnect manually
                console.log("Socket.io disconnected footer!! " + reason);
                socket.connect();
            }
            // else the socket will automatically try to reconnect
        });

        this.props.fetchUnits(this.props.loggedUser);
        //end bloco comum a todas as equipas
        //begin bloco de Portugal
        if(userCountry === 'PTG'){
            socket.on('closeAlarmModalResp',(res)=>{//quando um operador fecha o alarme, fecha para todos
                const userCompany = res.userCompany
                this.closeModalNewIndispsAlarms(userCompany);
            });        

            //timer para verificar se existem alarmes de indisps
            timerIndisps = setInterval(this.checkForIndispsAlarms, 10000);//avalia se existem IDs por executar de cada 10s
            this.setState({
                timerIndisps: timerIndisps
            });
            this.props.fetchOpenAlarms(this.props.loggedUser);//função que busca alarms de indisps

            //Administradores de Indidps e Conds
            if(INDISPADMIN){

                //Sockets de Indisps e Condicionamentos
                socket.on('refreshIO',(res)=>{
                    
                    //validar o país da IO
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //IO criada
                        if(res.operation === 'addNewIO' && res.actionOrigin !== 'UNGE'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitidas(s) nova(s) IO(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //IO recebida       
                        if(res.operation === 'receiveIO'){
                            this.playSound("indisp3");
                            notifyMe("SCP","Recebida a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //IO fechada. Apenas notificamos caso a ação tenha partido da EDPP
                        else if(res.operation === 'rejectIO' && res.actionOrigin !== 'UNGE'){
                            this.playSound("indisp1");
                            notifyMe("SCP","Fechada a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + " por parte da EDPP", window.location.href);
                        }
                        //IO aceite
                        else if(res.operation === 'acceptIO'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Aceite a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser); 
                });

                socket.on('refreshCI',(res)=>{
                    
                    //validar o país da CI
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //CI criada
                        if(res.operation === 'addNewCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CI(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI editada
                        else if(res.operation === 'editCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Editada a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI cancelada
                        else if(res.operation === 'cancelCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP",res.editedRecord.STATUS + " a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI reconhecida pela EDPP
                        else if(res.operation === 'seeCI'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Reconhecida a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + ", com origem na IO: " + res.editedRecord.ID_IO, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('deleteCI',(res)=>{
                    //validar o país da CI
                    if(res.countryCode === 'PTG'){
                        this.playSound("indisp1");
                        notifyMe("SCP","Eliminada a CI: " + res.id, window.location.href);
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshCC',(res)=>{
                    //validar o país da CC
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //CC criada
                        if(res.operation === 'addNewCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CC(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CC editada
                        else if(res.operation === 'editCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Editada a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CC cancelada
                        else if(res.operation === 'cancelCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP", res.editedRecord.STATUS + " a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('deleteCC',(res)=>{
                    //validar o país da CC
                    if(res.countryCode === 'PTG'){
                        this.playSound("indisp1");
                        notifyMe("SCP","Eliminada a CC: " + res.id, window.location.href);
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshFI',(res)=>{
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshFC',(res)=>{
                    this.props.fetchToDoList(this.props.loggedUser);
                });
                
                socket.on('importCIs',(res)=>{    
                    //new CIs from file
                    if(res.successFlag === true && res.countryCode === 'PTG'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitida(s) nova(s) CI(s) resultantes da importação de ficheiro.");
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('importCCs',(res)=>{    
                    //new CCs from file
                    if(res.successFlag === true && res.countryCode === 'PTG'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitida(s) nova(s) CC(s) resultantes da importação de ficheiro.");
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                this.props.fetchToDoList(this.props.loggedUser);
            }
            //Utilizadores com perfil de leitura
            else if(READER){

                this.props.fetchToDoList(this.props.loggedUser);
            }
            //Operadores do CTCH
            else if(CTCH){
            
                //timer para verificar se existem IDs a expirar
                timer = setInterval(this.checkForCloseIDs, 15000);//avalia se existem IDs por executar de cada 15s
                this.setState({
                    timer: timer
                });

                //Sockets de IDs Hídricas
                //temos todos os sockets sobre IDs como na página do CTCH porque queremos que a informação seja atualizada para n repetir 
                //os alarmes para IDs já atualizadas por parte do CTCH
                socket.on('instructionsAdded',(res)=>{
                    
                    let auxText = "\n";
                    let auxCodSIME = "";
                    let auxActiveAlarms = this.props.ctchActiveAlarms;
                    let auxOrigin = res[0]['COUNTRY_CODE'];
  
                    for (var i = 0; i < res.length; i++) {
                        
                        auxCodSIME = res[i]['COD_SIME'].substring(1);
                        auxText = auxText + auxCodSIME + "; \n";
                    }
                    auxText = "Novas IDs para as centrais: " + auxText;

                    if((auxActiveAlarms === 'all' || (auxActiveAlarms === 'edp' && auxOrigin === 'PTG') || (auxActiveAlarms === 'engie' && auxOrigin === 'MNT')) && this.props.soundsOn){
                        this.openModalNewIDs(auxText);          
                        this.props.instructionsAddReceived(res);
                    }else{
                        auxText = "";
                    }
                });

                socket.on('closeNewIDsModalResp', (res)=>{//quando um operador fecha o alarme, fecha para todos
                    const userCompany = res.userCompany;
                    this.closeModalNewIDs(userCompany);
                });

                socket.on('instructionSeen',(res)=>{
                    this.props.instructionSeeReceived(res)
                });

                socket.on('instructionRejected',(res)=>{
                    this.props.instructionRejectReceived(res)
                });     

                socket.on('instructionCanceled',(res)=>{       
                    if(res.status === 'EMITIDA' || res.status === 'CANCELADA'){

                        let auxCodSIME = res.codSime.substring(1);
                        this.playSound("bleep-sound");
                        notifyMe("SCP","Foi cancelada uma ID para a central: " + auxCodSIME, window.location.href);
                    }

                    this.props.instructionCancelReceived(res)
                });

                socket.on('instructionBanned',(res)=>{          

                    let auxCodSIME = res.codSime.substring(1);                   
                    this.playSound("computerError");
                    notifyMe("SCP","Reclamação de ID rejeitada para a central: " + auxCodSIME, window.location.href);

                    this.props.instructionBanReceived(res)
                });

                socket.on('instructionEdited',(res)=>{

                    let auxCodSIME = res.codSime.substring(1);
                    this.playSound("incorrect");
                    notifyMe("SCP","Edição da ID para a central: " + auxCodSIME, window.location.href);

                    this.props.instructionEditReceived(res);
                });

                socket.on('instructionValidated',(res)=>{//quando o CTCH executa IDs, refrescamos o conjunto de IDs para n voltarmos a alarmar para IDs já terminadas
                    this.props.instructionValidateReceived(res)
                }); 
            
                socket.on('instructionAlarmAlert',(res)=>{//quando o CTCH coloca alarmes, refrescamos o conjunto de IDs para n voltarmos a alarmar para IDs já terminadas
                    this.props.setUpAlarmInstructionReceived(res);
                });

                //Sockets de Indisps e Condicionamentos
                socket.on('refreshIO',(res)=>{          
                    //apenas alertamos o CTCH caso sejam IOs referentes a centrais Hídricas
                    if(res.editedRecord.TECHNOLOGY === 'Hídrica'){
                        //validar qual o tipo de operação
                        //IO criada
                        if(res.operation === 'addNewIO' && res.actionOrigin === 'UNGE'){
                            
                            let auxText = "Por favor verique a(s) IO(s) emita(s) para a central: " + res.editedRecord.G_UNIT;
                            this.openModalNewIOs(auxText);
                        }
                        //IO fechada. Apenas notificamos caso a ação tenha partido da UNGE
                        else if(res.operation === 'rejectIO' && res.actionOrigin === 'UNGE'){
                            this.playSound("indisp1");
                            notifyMe("SCP","Fechada a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + " por parte da UNGE", window.location.href);
                        }
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                socket.on('closeNewIOsModalResp', (res)=>{//quando um operador fecha o alarme, fecha para todos
                    const userCompany = res.userCompany;
                    this.closeModalNewIOs(userCompany);
                });

                if(userProfile === 'ADMINISTRADOR'){
                    //Sockets de Indisps e Condicionamentos
                    
                    socket.on('refreshCI',(res)=>{
                        //apenas alertamos o CTCH caso sejam CIs referentes a centrais Hídricas
                        if(res.editedRecord.TECHNOLOGY === 'Hídrica'){
                            //validar qual o tipo de operação
                            //CI devolvida
                            if(res.operation === 'rejectCI'){
                                this.playSound("indisp4");
                                notifyMe("SCP","Devolvida a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                            }
                            //CI aceite
                            else if(res.operation === 'acceptCI'){
                                this.playSound("indisp2");
                                notifyMe("SCP","Aceite a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                            }
                            this.props.fetchToDoList(this.props.loggedUser);
                        }
                    });
                    
                    socket.on('refreshFI',(res)=>{
                        //apenas alertamos o CTCH caso sejam FIs referentes a centrais Hídricas
                        if(res.editedRecord.TECHNOLOGY === 'Hídrica'){
                            //validar qual o tipo de operação
                            //FI editada
                            if(res.operation === 'editFI'){
                                this.playSound("indisp3");
                                notifyMe("SCP","Editada a CI: " + res.editedRecord.ID_CI + ", para a central: " + res.editedRecord.G_UNIT + " devido à edição pela UNGE da FI: " + res.editedRecord.ID, window.location.href);
                            }
                            //FI cancelada
                            else if(res.operation === 'cancelFI'){
                                this.playSound("indisp1");
                                notifyMe("SCP","Cancelada a CI: " + res.editedRecord.ID_CI + ", para a central: " + res.editedRecord.G_UNIT + " devido ao cancelamento pela UNGE da FI: " + res.editedRecord.ID, window.location.href);
                            }
                        }
                    });

                    socket.on('refreshCC',(res)=>{          
                        //apenas alertamos o CTCH caso sejam CCs referentes a centrais Hídricas
                        if(res.editedRecord.TECHNOLOGY === 'Hídrica'){
                            //validar qual o tipo de operação
                            //CC devolvida
                            if(res.operation === 'rejectCC'){
                                this.playSound("indisp4");
                                notifyMe("SCP","Devolvida a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                            }
                            //CC aceite
                            else if(res.operation === 'acceptCC'){
                                this.playSound("indisp2");
                                notifyMe("SCP","Aceite a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                            }
                            this.props.fetchToDoList(this.props.loggedUser);
                        }
                    });

                    socket.on('refreshFC',(res)=>{          
                        //apenas alertamos o CTCH caso sejam FCs referentes a centrais Hídricas
                        if(res.editedRecord.TECHNOLOGY === 'Hídrica'){
                            //validar qual o tipo de operação
                            //FC editada
                            if(res.operation === 'editFC'){
                                this.playSound("indisp3");
                                notifyMe("SCP","Editada a CC: " + res.editedRecord.ID_CC + ", para a central: " + res.editedRecord.G_UNIT + " devido à edição pela UNGE da FC: " + res.editedRecord.ID, window.location.href);
                            }
                        }
                    });

                    socket.on('importCIs',(res)=>{    
                        //new CIs from file
                        if(res.successFlag === true){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CI(s) resultantes da importação de ficheiro.");
                            this.props.fetchToDoList(this.props.loggedUser);
                        }
                    });
    
                    socket.on('importCCs',(res)=>{    
                        //new CCs from file
                        if(res.successFlag === true){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CC(s) resultantes da importação de ficheiro.");
                            this.props.fetchToDoList(this.props.loggedUser);
                        }
                    });

                }
                //faz fetch das instruções e das regras dos alarmes
                this.props.fetchInboxInstructions(this.props.loggedUser);
                this.props.fetchRule('PRODUCTION_ALARM',"'PROD_HIDRO_ALARM'");//Vai obter a regra sobre ligar ou desligar os alarmes sobre o tempo de acção sobre as IDs emitidas
                this.props.fetchToDoList(this.props.loggedUser);

            }
            //Operadores do Despacho da UNGE
            else if(UNGE){

                //timer para verificar se existem alterações nas IDs
                timerDIsRefresh = setInterval(this.checkForDIsChanges, 10000);
                this.setState({
                    timerDIsRefresh: timerDIsRefresh
                });
                
                //IDs Hídricas
                socket.on('instructionsAdded',(res)=>{
                    let countryCode = res[0]['COUNTRY_CODE'];
                    if(countryCode === 'PTG'){
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });
                
                socket.on('instructionCanceled',(res)=>{       
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.props.instructionCancelReceived(res);
                        //this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });

                socket.on('instructionBanned',(res)=>{          
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });

                socket.on('instructionEdited',(res)=>{
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });

                socket.on('instructionValidated',(res)=>{
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.playSound("sms-tone");
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });        

                socket.on('instructionSeen',(res)=>{
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.playSound("bleep-sound");
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });
                
                socket.on('instructionRejected',(res)=>{
                    let countryCode = res.countryCode;
                    if(countryCode === 'PTG'){
                        this.playSound("computerError");
                        notifyMe("SCP","IDs Hídricas reclamadas!", window.location.href);
                        this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                    }
                });

                //Térmicas
                socket.on('instructionTermAccepted',(res)=>{
                    this.playSound("sms-tone");
                });

                socket.on('instructionTermRejected',(res)=>{
                    this.playSound("computerError");
                    notifyMe("SCP","IDs Térmicas reclamadas!", window.location.href);
                });
        
                //Sockets de Indisps e Condicionamentos
                socket.on('refreshIO',(res)=>{
                    
                    //validar o país da IO
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //IO criada
                        if(res.operation === 'addNewIO' && res.actionOrigin !== 'UNGE'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitidas(s) nova(s) IO(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //IO recebida       
                        if(res.operation === 'receiveIO'){
                            this.playSound("indisp3");
                            notifyMe("SCP","Recebida a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //IO fechada. Apenas notificamos caso a ação tenha partido da EDPP
                        else if(res.operation === 'rejectIO' && res.actionOrigin !== 'UNGE'){
                            this.playSound("indisp1");
                            notifyMe("SCP","Fechada a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + " por parte da EDPP", window.location.href);
                        }
                        //IO aceite
                        else if(res.operation === 'acceptIO'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Aceite a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshCI',(res)=>{
                    
                    //validar o país da CI
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //CI criada
                        if(res.operation === 'addNewCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CI(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI editada
                        else if(res.operation === 'editCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Editada a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI cancelada
                        else if(res.operation === 'cancelCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP", res.editedRecord.STATUS + " a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI reconhecida pela EDPP
                        else if(res.operation === 'seeCI'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Reconhecida a CI: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + ", com origem na IO: " + res.editedRecord.ID_IO, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('deleteCI',(res)=>{
                    //validar o país da CI
                    if(res.countryCode === 'PTG'){
                        this.playSound("indisp1");
                        notifyMe("SCP","Eliminada a CI: " + res.id, window.location.href);
                       
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshCC',(res)=>{
                    //validar o país da CC
                    if(res.editedRecord.COUNTRY_CODE === 'PTG'){
                        //validar qual o tipo de operação
                        //CC criada
                        if(res.operation === 'addNewCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Emitida(s) nova(s) CC(s) para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CC editada
                        else if(res.operation === 'editCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Editada a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CC cancelada
                        else if(res.operation === 'cancelCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP", res.editedRecord.STATUS + " a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('deleteCC',(res)=>{
                    //validar o país da CC
                    if(res.countryCode === 'PTG'){
                        this.playSound("indisp1");
                        notifyMe("SCP","Eliminada a CC: " + res.id, window.location.href);
                    }
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshFI',(res)=>{
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('refreshFC',(res)=>{
                    this.props.fetchToDoList(this.props.loggedUser);
                });

                socket.on('importCIs',(res)=>{    
                    //new CIs from file
                    if(res.successFlag === true && res.countryCode === 'PTG'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitida(s) nova(s) CI(s) resultantes da importação de ficheiro.");
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                socket.on('importCCs',(res)=>{    
                    //new CCs from file
                    if(res.successFlag === true && res.countryCode === 'PTG'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitida(s) nova(s) CC(s) resultantes da importação de ficheiro.");
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                this.props.fetchEcoDispatchInstructions(this.props.loggedUser);
                this.props.fetchToDoList(this.props.loggedUser);
            }
            //Operadoras das Térmicas
            else if(SINES || LARES || RIBATEJO){

                //Sockets de IDs
                socket.on('instructionsTermAdded',(res)=>{

                    let flagEmitAlert = false;
                    let auxText = "\n";
                    for (var i = 0; i < res.length; i++) {

                        //apenas emitimos alerta para centrais do grupo do utilizador
                        if(res[i]['COD_SIME'].substring(0, 4) === userCompany){
                            flagEmitAlert = true;
                            auxText = auxText + res[i]['COD_SIME'] + "; \n";
                        }
                    }
                    auxText = "Novas IDs para as centrais: " + auxText;
                    if(flagEmitAlert === true){
                        this.openModalNewIDs(auxText);   
                    }
                });

                socket.on('closeNewIDsModalResp', (res)=>{//quando um operador fecha o alarme, fecha para todos
                    const userCompany = res.userCompany;
                    this.closeModalNewIDs(userCompany);
                });

                socket.on('instructionTermEdited',(res)=>{

                    if(res.instruction['COD_SIME'].substring(0, 4) === userCompany){
                        this.playSound("computerError");
                        notifyMe("SCP","Edição da ID para a central: " + res.codSime, window.location.href);
                    }
                });

                socket.on('instructionTermBanned',(res)=>{
                    if(res.instructionCod_Sime.substring(0, 4) === userCompany){
                        this.playSound("computerError");
                    }
                });

                socket.on('instructionTermCanceled',(res)=>{
                    
                    if(res.codSime.substring(0, 4) === userCompany){
                        this.playSound("bleep-sound");
                        notifyMe("SCP","Foi cancelada uma ID para a central: " + res.codSime, window.location.href);
                    }
                });
                
                //Sockets de Indisps e Condicionamentos
                socket.on('refreshIO',(res)=>{          
                    //apenas alertamos a Central caso sejam CIs referentes à sua Central
                    if(res.editedRecord.TECHNOLOGY === 'Térmica' && res.editedRecord.G_UNIT.substring(0, 4) === userCompany){
                        //validar qual o tipo de operação
                        //IO criada
                        if(res.operation === 'addNewIO' && res.actionOrigin === 'UNGE'){
                            let auxText = "Por favor verique a IO emita para o grupo: " + res.editedRecord.G_UNIT;
                            this.openModalNewIOs(auxText);

                        }
                        //IO fechada. Apenas notificamos caso a ação tenha partido da UNGE
                        else if(res.operation === 'rejectIO' && res.actionOrigin === 'UNGE'){
                            this.playSound("indisp1");
                            notifyMe("SCP","Fechada a IO: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT + " por parte da UNGE", window.location.href);
                        }
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                socket.on('closeNewIOsModalResp', (res)=>{//quando um operador fecha o alarme, fecha para todos
                    const userCompany = res.userCompany;
                    this.closeModalNewIOs(userCompany);
                });

                socket.on('refreshCI',(res)=>{
                    //apenas alertamos a Central caso sejam CIs referentes à sua Central
                    if(res.editedRecord.TECHNOLOGY === 'Térmica' && res.editedRecord.G_UNIT.substring(0, 4) === userCompany){
                        //validar qual o tipo de operação
                        //CI devolvida
                        if(res.operation === 'rejectCI'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Devolvida a CI: " + res.editedRecord.ID + ", para o grupo: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CI aceite
                        else if(res.operation === 'acceptCI'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Aceite a CI: " + res.editedRecord.ID + ", para o grupo: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                socket.on('refreshFI',(res)=>{
                    //apenas alertamos a Central caso sejam CIs referentes à sua Central
                    if(res.editedRecord.TECHNOLOGY === 'Térmica' && res.editedRecord.G_UNIT.substring(0, 4) === userCompany){
                        //validar qual o tipo de operação
                        //FI editada
                        if(res.operation === 'editFI'){
                            this.playSound("indisp3");
                            notifyMe("SCP","Editada a CI: " + res.editedRecord.ID_CI + ", para a central: " + res.editedRecord.G_UNIT + " devido à edição pela UNGE da FI: " + res.editedRecord.ID, window.location.href);
                        }
                        //FI cancelada
                        else if(res.operation === 'cancelFI'){
                            this.playSound("indisp1");
                            notifyMe("SCP","Cancelada a CI: " + res.editedRecord.ID_CI + ", para a central: " + res.editedRecord.G_UNIT + " devido ao cancelamento pela UNGE da FI: " + res.editedRecord.ID, window.location.href);
                        }
                    }
                });

                socket.on('refreshCC',(res)=>{          
                    //apenas alertamos a Central caso sejam CIs referentes à sua Central
                    if(res.editedRecord.TECHNOLOGY === 'Térmica' && res.editedRecord.G_UNIT.substring(0, 4) === userCompany){
                        //validar qual o tipo de operação
                        //CC devolvida
                        if(res.operation === 'rejectCC'){
                            this.playSound("indisp4");
                            notifyMe("SCP","Devolvida a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        //CC aceite
                        else if(res.operation === 'acceptCC'){
                            this.playSound("indisp2");
                            notifyMe("SCP","Aceite a CC: " + res.editedRecord.ID + ", para a central: " + res.editedRecord.G_UNIT, window.location.href);
                        }
                        this.props.fetchToDoList(this.props.loggedUser);
                    }
                });

                socket.on('refreshFC',(res)=>{          
                    //apenas alertamos a Central caso sejam CIs referentes à sua Central
                    if(res.editedRecord.TECHNOLOGY === 'Térmica' && res.editedRecord.G_UNIT.substring(0, 4) === userCompany){
                        //validar qual o tipo de operação
                        //FC editada
                        if(res.operation === 'editFC'){
                            this.playSound("indisp3");
                            notifyMe("SCP","Editada a CC: " + res.editedRecord.ID_CC + ", para a central: " + res.editedRecord.G_UNIT + " devido à edição pela UNGE da FC: " + res.editedRecord.ID, window.location.href);
                        }
                    }
                });
                this.props.fetchToDoList(this.props.loggedUser);
            }
            //user mal configurado
            else{
                console.log('review user profile PTG!')
            }
        }
        //end bloco de Portugal
        //begin bloco de Espanha
        else if(userCountry === 'ESP'){
            this.props.fetchRule('ESP_CONFIG_VALUES',"'HC_DEST_FUNC','HC_DEST_ID','HC_DEST_ID_COD','HC_IS_BUS_TYPE','HC_IS_CLASS_TYPE','HC_IS_MSG_ID_PREFIX','HC_IS_MSG_TYPE','HC_IS_PRC_TYPE','HC_PM_DAY_LIMIT_REE','HC_PM_CLASS_TYPE','HC_PM_MSG_ID_PREFIX','HC_PM_MSG_TYPE','HC_PM_PRC_TYPE','HC_REM_FUNC','HC_REM_ID','HC_REM_ID_COD','HC_UF_COD','HC_MEASURE_UNIT','EDPCL_DEST_FUNC','EDPCL_DEST_ID','EDPCL_DEST_ID_COD','EDPCL_IS_BUS_TYPE','EDPCL_IS_CLASS_TYPE','EDPCL_IS_MSG_ID_PREFIX','EDPCL_IS_MSG_TYPE','EDPCL_IS_PRC_TYPE','EDPCL_PM_DAY_LIMIT_REE','EDPCL_PM_CLASS_TYPE','EDPCL_PM_MSG_ID_PREFIX','EDPCL_PM_MSG_TYPE','EDPCL_PM_PRC_TYPE','EDPCL_REM_FUNC','EDPCL_REM_ID','EDPCL_REM_ID_COD','EDPCL_UF_COD','EDPCL_MEASURE_UNIT'");
            this.props.fetchToDoHCList(this.props.loggedUser);
            //Produção HC
            if(PRODHC || COMHC){
                socket.on('refreshCP',(res)=>{          
                    //validar qual o tipo de operação
                    //CP devolvida
                    if(res.operation === 'rejectCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Se ha devuelto la CP: " + res.editedRecord.ID + ", para la unidad: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    //CC aceite
                    else if(res.operation === 'acceptCP'){
                        this.playSound("indisp2");
                        notifyMe("SCP","Se aceptó la CP: " + res.editedRecord.ID + ", para la unidad: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });
            } 
            //GDE HC
            else if(GDEHC){
                socket.on('refreshCP',(res)=>{
                    //validar qual o tipo de operação
                    //CC criada
                    if(res.operation === 'addNewCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitidas nuevas CP para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    //CC editada
                    else if(res.operation === 'editCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Ha sido editada la CP: " + res.editedRecord.ID + ", para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    //CC cancelada
                    else if(res.operation === 'cancelCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP", "Ha sido cancelada la CP: " + res.editedRecord.ID + ", para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });

                socket.on('refreshFP',(res)=>{
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });   

                socket.on('deleteCP',(res)=>{
                    this.playSound("indisp1");
                    notifyMe("SCP","Ha sido borrada la CP: " + res.id, window.location.href);
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });            
            }
            //DGE HC
            else if(DGEHC){
                socket.on('refreshIS',(res)=>{
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });
                socket.on('errorIS',(res)=>{
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });
            }
            //user mal configurado
            else{
                console.log('review user profile ESP!')
            }
        }
        //end bloco de Espanha
        //begin bloco de Abono
        else if(userCountry === 'ABO'){
            this.props.fetchRule('ESP_CONFIG_VALUES',"'HC_UF_COD','HC_MEASURE_UNIT','HC_PM_DAY_LIMIT_REE','ABOGE_DEST_FUNC','ABOGE_DEST_ID','ABOGE_DEST_ID_COD','ABOGE_IS_BUS_TYPE','ABOGE_IS_CLASS_TYPE','ABOGE_IS_MSG_ID_PREFIX','ABOGE_IS_MSG_TYPE','ABOGE_IS_PRC_TYPE','ABOGE_PM_DAY_LIMIT_REE','ABOGE_PM_CLASS_TYPE','ABOGE_PM_MSG_ID_PREFIX','ABOGE_PM_MSG_TYPE','ABOGE_PM_PRC_TYPE','ABOGE_REM_FUNC','ABOGE_REM_ID','ABOGE_REM_ID_COD','ABOGE_UF_COD','ABOGE_MEASURE_UNIT'");
            this.props.fetchToDoHCList(this.props.loggedUser);
            //GDE ABO
            if(GDEABO){
                socket.on('refreshCP',(res)=>{
                    //validar qual o tipo de operação
                    //CC criada
                    if(res.operation === 'addNewCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Emitidas nuevas CP para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    //CC editada
                    else if(res.operation === 'editCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP","Ha sido editada la CP: " + res.editedRecord.ID + ", para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    //CC cancelada
                    else if(res.operation === 'cancelCP'){
                        this.playSound("indisp4");
                        notifyMe("SCP", "Ha sido cancelada la CP: " + res.editedRecord.ID + ", para la central: " + res.editedRecord.G_UNIT, window.location.href);
                    }
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });

                socket.on('refreshFP',(res)=>{
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });   

                socket.on('deleteCP',(res)=>{
                    this.playSound("indisp1");
                    notifyMe("SCP","Ha sido borrada la CP: " + res.id, window.location.href);
                    this.props.fetchToDoHCList(this.props.loggedUser);
                });            
            }
            //user mal configurado
            else{
                console.log('review user profile ABO!')
            }
        }
        //end bloco de Abono
    };

    componentWillUnmount() {
        socket.disconnect();
        clearInterval(timer);
        clearInterval(timerIndisps);
        clearInterval(timerSocketStatus);
        clearInterval(timerDIsRefresh);
        this.setState({
            timer: null,
            timerIndisps: null,
            timerSocketStatus: null,
            timerDIsRefresh: null
        });
    };

    //Check Socket Status - avaliar se a sessão está a conectada ao servidor
    checkSocketStatus(){
        //console.log('socket status: ' + socket.connected + ' ; ' + this.state.errorReconnectAttempts);
        if(socket.connected === false && this.state.errorReconnectAttempts < 4){//tentamos reconectar primeiro 4 vezes antes de alarmarmos operadores de que perderam a sessão
            this.setState({
                errorReconnectAttempts: this.state.errorReconnectAttempts + 1
            });
            socket.connect();
        }else if(socket.connected === false && this.state.errorReconnectAttempts >= 4){//se após 4 tentativas n se reconectar, alerta a pedir refresh
            var sound = document.getElementById("alarmSound");
            sound.play();
            socket.connect();
            alert('!!---- Erro! Perdeu a sua sessão inesperadamente. Por favor, verifique se a sua sessão está a funcionar como esperado, e caso não esteja, faça refresh à aplicação. ----!!');
            window.location.reload(true);
            this.setState({
                errorReconnectAttempts: this.state.errorReconnectAttempts + 1
            });
        }
    }

    //function to alert operators that there are IDs with execution time aproaching, and those IDs are yet to receive acceptance
    checkForCloseIDs() {

        //apenas corre se alarme estiver ligado
        if(this.props.ruleAlarm === 'ON'){
                    
            let instructions = this.props.inboxInstructions;
            let myStartTime;
            const timezone = this.props.loggedUser.profile.TIMEZONE;
            let realTime = moment.tz(timezone);
            let newMessage = '';
            if (instructions.length !== 0) {
                instructions.forEach((item) => {
                    //caso em que ID tem alarme ativo 
                    if(item.ALARM_DATETIME !== null && item.ALARM_DATETIME !== ''){
                        myStartTime = moment.utc(item.ALARM_DATETIME, 'YYYY-MM-DD HH:mm:ss').tz(timezone) - (15000);//data-hora alarme menos 15s
                        if(myStartTime < realTime){//falta menos de 1min para o tempo de alarme
                            //alarme para hora de arranque                 
                            if(item.START_ON_DATE !== '' && item.START_ON_DATE !== null){
                                newMessage = newMessage + "Atenção à hora de ARRANQUE para a ID da Central " + item.COD_SIME.substring(1) + "! \n";
                            //alarme para hora de início
                            }else{
                                newMessage = newMessage + "Atenção à hora de INÍCIO para a ID da Central " + item.COD_SIME.substring(1) + "! \n";
                            }
                        }
                    }
                });
            }

            if(newMessage.length > 0){
                this.playSound("incorrect");
                notifyMe("SCP",newMessage, window.location.href);
            }
        }
    }

    //Alertas de novas IDs
    //Abre modal de novas IDs
    openModalNewIDs(auxMessage) {     
        
        soundAlarmNewIds = document.getElementById("newIDs");
        //apenas toca caso tenha a flag ativa
        if(this.props.soundsOn){
            soundAlarmNewIds.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play();
            }, false);
            soundAlarmNewIds.play();
        }
        this.setState({ 
            modalOpenNewIDs: true,
            newMessageNewIDs: auxMessage
        });

        var modalFocus = document.getElementById("modalFocusNewIDs");
        modalFocus.focus();
    };

    //Função que emite socket para desligar todos os modals de novas IDs que disparam nas sessões do CTCH
    //resposta do servidor faz com que o modal seja fechado
    emitToCloseModalNewIDs() {
        let postData = {
            loggedUser: this.props.loggedUser
        }
        socket.emit('closeNewIDsModal',postData);
    };

    //Fecha modal de alertas de novas IDs
    closeModalNewIDs(userCompany) {
        
        //apenas fechamos o modal caso algum utilizador da nossa equipa já o tenha visto
        if(this.props.user.profile.COMPANY === userCompany){         
            soundAlarmNewIds.pause();
            soundAlarmNewIds.currentTime = 0;
            soundAlarmNewIds = null;

            this.setState({ 
                modalOpenNewIDs: false
            });
        }
    };

    //Novos ficheiros processados (Indisps e Conds)
    //Procura novos registos
    checkForIndispsAlarms(){
        let alarms = this.props.indispsAlarms;
        let newMessage = '';
        let arrayMain=[];
        let newItem = {};
        if (alarms.length !== 0) {
            alarms.forEach((item) => {
                newMessage = item.TYPE + ' número ' + item.FILE_ID + ": " + item.ALARM_MESSAGE;
                //foi processada como " + item.STATUS + ", com a seguinte mensagem: " + item.ALARM_MESSAGE + ';';
                newItem = {};
                newItem['MESSAGE'] = newMessage;//limpa para criar um novo
                newItem['ID'] = item.ID;//limpa para criar um novo
                //fazer set de state destes valores como auxiliares para criar valdiações
                arrayMain.push(newItem);
            });
            this.openModalNewIndispsAlarms(arrayMain);
        }
        this.props.fetchOpenAlarms(this.props.loggedUser);
    }
    
    //Abre modal de ficheiros processados
    openModalNewIndispsAlarms(arrayMain) {
        
        soundAlarmIndisp = document.getElementById("newAlarmIndisps");
        //apenas toca caso tenha a flag ativa
        if(this.props.soundsOn){
            soundAlarmIndisp.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play();
            }, false);
            soundAlarmIndisp.play();
        }

        this.setState({ 
            modalOpenNewIndispsAlarms: true,
            newAlarmMessage: arrayMain,
            arrayMain: arrayMain       
        });
        var modalFocus = document.getElementById("modalFocusNewIndispsAlarms");
        modalFocus.focus();
    };    

    //Função que emite socket para desligar todos os modals de ficheiros procesados que disparam nas várias sessões
    //resposta do servidor faz com que o modal seja fechado
    emitToCloseModalNewIndispsAlarms(){
        let postData = {
            loggedUser: this.props.loggedUser,
            arrayIds: this.state.arrayMain
        }
        socket.emit('closeAlarmModal',postData);
    }

    //Fecha modal de alertas de ficheiros processados
    closeModalNewIndispsAlarms(userCompany) {

        //apenas fechamos o modal caso algum utilizador da nossa equipa já o tenha visto
        if(this.props.user.profile.COMPANY === userCompany){

            if(soundAlarmIndisp){
                soundAlarmIndisp.pause();
                soundAlarmIndisp.currentTime = 0;
                soundAlarmIndisp = null;
    
                this.setState({ 
                    modalOpenNewIndispsAlarms: false
                });
            }

            this.props.fetchOpenAlarms(this.props.loggedUser);
        }
    };

    //Novas IOs
    //Abre modal de novas IOs
    openModalNewIOs(auxMessage) {     

        soundAlarmNewIOs = document.getElementById("newIOs");
        //apenas toca caso tenha a flag ativa
        if(this.props.soundsOn){
            soundAlarmNewIOs.addEventListener('ended', function() {
                this.currentTime = 0;
                this.play();
            }, false);
            soundAlarmNewIOs.play();
        }
        this.setState({ 
            modalOpenNewIOs: true,
            newMessageNewIOs: auxMessage
        });

        var modalFocus = document.getElementById("modalFocusNewIOs");
        modalFocus.focus();
    };

    //Função que emite socket para desligar todos os modals de novas IDs que disparam nas sessões do CTCH
    //resposta do servidor faz com que o modal seja fechado
    emitToCloseModalNewIOs() {
        let postData = {
            loggedUser: this.props.loggedUser
        }
        socket.emit('closeNewIOsModal',postData);
    };

    //Fecha modal de alertas de novas IDs
    closeModalNewIOs(userCompany) {
        
        //apenas fechamos o modal caso algum utilizador da nossa equipa já o tenha visto
        if(this.props.user.profile.COMPANY === userCompany){
            soundAlarmNewIOs.pause();
            soundAlarmNewIOs.currentTime = 0;
            soundAlarmNewIOs = null;

            this.setState({ 
                modalOpenNewIOs: false
            });
        }
    };

    //Corre o som pedido caso tenha a flag de som ativa
    playSound(soundId) {
        if(this.props.soundsOn){
            var sound = document.getElementById(soundId);
            sound.load();
            sound.play();
        }
    };

    //Fetch DIs changes 
    checkForDIsChanges() {
        this.props.refreshDIsSocket(socket, this.props.EDInstructions, this.props.loggedUser);
    };

    render() { 
        return (
            <Container>
                <Modal 
                    open={this.state.modalOpenNewIDs} 
                    style={inlineStyle.modal}
                    onKeyDown={e => 
                        e.keyCode === 13 ? this.emitToCloseModalNewIDs() : ''
                    }
                    tabIndex={-1}
                    id='modalFocusNewIDs'
                >
                    <Modal.Header>
                        <Header as='h3'><FormattedMessage id="message.newIDs" /></Header>
                    </Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Header as='h5'>{this.state.newMessageNewIDs}</Header>
                            <Button id='confirmButton' type='button' positive onClick={this.emitToCloseModalNewIDs}><FormattedMessage id="word.close" /></Button>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
                <Modal 
                    open={this.state.modalOpenNewIndispsAlarms} 
                    style={inlineStyle.modal}
                    onKeyDown={e => 
                        e.keyCode === 13 ? this.emitToCloseModalNewIndispsAlarms() : ''
                    }
                    tabIndex={-1}
                    id='modalFocusNewIndispsAlarms'
                >
                    <Modal.Header>
                        <Header as='h3'><FormattedMessage id="message.processedFiles" /></Header>
                    </Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            { this.state.newAlarmMessage.map((item, index) => (
                                <p  key={index}>{item.MESSAGE}</p>
                            )) }
                            <Button id='confirmButton' type='button' positive onClick={this.emitToCloseModalNewIndispsAlarms}><FormattedMessage id="word.close" /></Button>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
                <Modal 
                    open={this.state.modalOpenNewIOs} 
                    style={inlineStyle.modal}
                    onKeyDown={e => 
                        e.keyCode === 13 ? this.emitToCloseModalNewIOs() : ''
                    }
                    tabIndex={-1}
                    id='modalFocusNewIOs'
                >
                    <Modal.Header>
                        <Header as='h3'><FormattedMessage id="message.newIO" /></Header>
                    </Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Header as='h5'>{this.state.newMessageNewIOs}</Header>
                            <Button id='confirmButton' type='button' positive onClick={this.emitToCloseModalNewIOs}><FormattedMessage id="word.close" /></Button>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
                <div>
                    <audio id='bleep-sound' style={{display: 'none'}} src='/Bleep-sound.mp3' preload='auto'/>
                    <audio id='computerError' style={{display: 'none'}} src='/computerError.mp3' preload='auto'/>
                    <audio id='sms-tone' style={{display: 'none'}} src='/sms-tone.mp3' preload='auto'/>
                    <audio id='incorrect' style={{display: 'none'}} src='/incorrect.mp3' preload='auto'/>
                    <audio id='newIDs' style={{display: 'none'}} src='/novasIDs.mp3' preload='auto'/>
                    <audio id='newIOs' style={{display: 'none'}} src='/indisp2.mp3' preload='auto'/>
                    <audio id='newAlarmIndisps' style={{display: 'none'}} src='/indisp1.mp3' preload='auto'/>
                    <audio id='indisp4' style={{display: 'none'}} src='/indisp4.mp3' preload='auto'/>
                    <audio id='indisp3' style={{display: 'none'}} src='/indisp3.mp3' preload='auto'/>
                    <audio id='indisp2' style={{display: 'none'}} src='/indisp2.mp3' preload='auto'/>
                    <audio id='indisp1' style={{display: 'none'}} src='/indisp1.mp3' preload='auto'/>
                    <audio id='alarmSound' style={{display: 'none'}} src='/alarmSound.mp3' preload='auto'/>
                </div>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        inboxInstructions: state.footerStore.inboxInstructions,
        indispsAlarms: state.footerStore.indispsAlarms,
        ruleAlarm: state.footerStore.ruleAlarm,
        units: state.footerStore.units,
        ctchActiveAlarms: state.footerStore.ctchActiveAlarms,
        loggedUser: state.loginStore.user,
        soundsOn: state.toDoStore.soundsOn,
        EDInstructions : state.footerStore.EDInstructions
    };
};  
export default connect(
    mapStateToProps, 
    {
        fetchInboxInstructions,
        fetchRule,
        instructionsAddReceived,
        instructionCancelReceived,
        instructionValidateReceived,
        instructionSeeReceived,
        instructionRejectReceived,
        instructionBanReceived,
        instructionEditReceived,
        setUpAlarmInstructionReceived,
        fetchOpenAlarms,
        fetchUnits,
        fetchToDoList,
        fetchToDoHCList,
        refreshDIsSocket,
        fetchEcoDispatchInstructions
    }
)(LayoutFooter);
  



// WEBPACK FOOTER //
// ./src/components/layout-footer.js